/**
 * List of available settings scopes exposed via the API.
 *
 * @see mobiz1:Mobiz.Data.SettingsScope
 * @see mobiz1:Mobiz.Web.Controllers.Api.SettingsController
 */
export type MobizSettingsScope = 'system' | 'organization' | 'user';
